import defs from '../_core/defs.js';
import forOwn from '../_helpers/forown.js';
// iterates over data keys and calls callback on every iteration
// @IE for..of is preferable and the method will be removed in one of major versions
export default function each(callback, thisArg) {
  var _this = this;
  var def = defs.get(this);
  var ctx = typeof thisArg !== 'undefined' ? thisArg : this;
  /* istanbul ignore if */
  if (!def) {
    return this;
  }
  forOwn(def.keys, function (_, key) {
    callback.call(ctx, _this[key], key, _this);
  });
  return this;
}